<template>
  <main>
    <b-container>
        <div class="page-breadcrumb">
            <router-link :to="{ name: 'ManageAccess' }"
                ><i class="fa fa-angle-left" /> Back to Manage Access</router-link
            >
        </div>

        <div class="section-header">
            <h1 class="heading">Create Realm</h1>

            <div class="actions"></div>
        </div>

        <div class="layoutcard">
            <b-row>
                    <b-col cols="8" lg="7">
                        <b-form @submit.prevent="submit">
                        <b-row>

                            <b-col cols="6">
                                <b-form-group
                                id="input-group-realm-name"
                                label="Realm name"
                                label-for="input-realm-name"
                                >
                                <b-form-input
                                    id="input-realm-name"
                                    v-model.trim="form.realmName"
                                    v-validate="{ required: true, max: 100 }"
                                    type="text"
                                    placeholder="Realm name"
                                    size="lg"
                                    data-vv-name="realm-name"
                                ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group
                                id="input-group-users"
                                label="Users"
                                label-for="input-users"
                                >
                                <b-form-input
                                    id="input-users"
                                    v-model.trim="form.users"
                                    v-validate="{ required: true, max: 100 }"
                                    type="number"
                                    placeholder="Users"
                                    size="lg"
                                    data-vv-name="users"
                                ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col class="text-right" cols="12">
                                <div class="form-footer">
                                <b-btn variant="primary" size="lg" type="submit">
                                    <i class="fa fa-plus" /> Save
                                </b-btn>
                                </div>
                            </b-col>
                        </b-row>
                        </b-form>
                    </b-col>
            </b-row>
        </div>
    </b-container>
  </main>
</template>

<script>
import { setTimeout } from "timers";
import { mapActions } from "vuex";
import InitAdmin from "../Shared/InitAdmin";

export default {
  name: "realmCreate",
  components: {
  },
  extends: InitAdmin,
  data() {
    return {
      form: {
        realmName: null,
        users: null
      }
    };
  },
  methods: {
    ...mapActions(["saveRealm"]),
    submit() {
      let data = {
        companyname: this.form.realmName,
        employees: this.form.users
      };

      this.saveRealm({
        realm: data
      }).then(res => {
        this.$toasted.show("Realm created");
        setTimeout(() => {
          this.$router.push({ name: "ManageAccess" });
        }, 1000);
      });
    }
  }
};
</script>
